define('controller/disclosure/disclosure.history.tab.controller',['require','exports','module','controller/disclosure/disclosure.tab.controller','model/disclosure.detail.model','model/review.person.model','model/person.model','model/user.model','model/outcome.model','model/disclosure.routing.history.model','fukit','model/disclosure.comment.model','model/previous.reviewer.model','model/settings.model','view/disclosure/disclosure.history.tab.page.view'],function(require, exports, module) {
  //prettier-ignore
  var DisclosureTabController       = require('controller/disclosure/disclosure.tab.controller'),

      DisclosureDetailModel         = require('model/disclosure.detail.model'),
      ReviewerPersonModel           = require('model/review.person.model'),
      PersonModel                   = require('model/person.model'),
      UserModel                     = require('model/user.model'),
      OutcomeModel                  = require('model/outcome.model'),
      DisclosureRoutingHistoryModel = require('model/disclosure.routing.history.model'),
      ResourceQueryCollection       = require('fukit').ResourceQueryCollection,
      DisclosureCommentModel        = require('model/disclosure.comment.model'),
      PreviousReviewerModel         = require('model/previous.reviewer.model'),
      SettingsModel                 = require('model/settings.model'),

      DisclosureHistoryTabPageView  = require('view/disclosure/disclosure.history.tab.page.view');

  var DisclosureHistoryTabController = DisclosureTabController.extend({
    radioRequests: {
      'controllers DisclosureHistoryTabController': '@constructor',
    },

    pageView: DisclosureHistoryTabPageView,

    resources: {
      //Disclosure related models
      disclosure: {
        fetchOnStart: true,
        model: DisclosureDetailModel,
        attrs: {
          id: '@state.primaryId',
        },
      },
      disclosureAssignmentDetailModel: {
        resourcePath: '@resources.disclosure.assignmentDetailModel',
      },

      //Workflow related models and collections
      workflowActivityStateModel: {
        model: Backbone.Model,
      },
      workflowTaskModel: {
        required: false,
        resourcePath: '@resources.disclosure.workflowTaskModel',
      },
      availableReviewersCollection: {
        required: true,
        resourceOptions:{
          paginate: {
            size: 1000
          }
        },
        collection: ReviewerPersonModel.Collection,
      },
      settingsModel: {
        model: SettingsModel,
        fetchOnStart: true,
        fetchWhenNew: true
      },

      //models and collections needed for modals linked from my tasks
      sessionDecisionModel: {
        required: false,
        fetchOnStart: true,
        resourcePath: '@resources.disclosure.sessionDecisionModel',
      },
      outcomeCollection: {
        collection: OutcomeModel.Collection,
        required: false,
        sort: {
          field: 'description',
          direction: 'ascending',
        },
      },

      disclosureCommentModel: {
        model: DisclosureCommentModel,
      },
      previousReviewerModel: {
        required: false,
        model: PreviousReviewerModel,
      },

      //Routing history data for the process history table
      routingHistoryCollection: {
        fetchOnStart: true,
        collection: ResourceQueryCollection.extend({
          model: PersonModel,
          query: {
            select: [{ from: 'RoutingHistory.*' }, { from: 'Person.firstName' }, { from: 'Person.lastName' }],
            select: [{ from: 'RoutingHistory.*' }, { from: 'Person.firstName' }, { from: 'Person.lastName' }],
            resourceClass: DisclosureRoutingHistoryModel.Collection,
            as: 'RoutingHistory',
            urlParams: {
              documentId: '@state.primaryId',
            },
            join: [
              {
                as: 'Person',
                resourceClass: PersonModel.Collection,
                joinType: 'leftOuterJoin',
                on: {
                  userAccountId: 'RoutingHistory.assignee',
                },
              },
            ],
            sort: {
              field: 'RoutingHistory.completionTime',
              direction: 'descending',
            },
          },
        }),
      },

      completedHistoryModel: {
        model: Backbone.Model,
      },
    },

    onStart: function() {
      //call original onStart methods from template
      DisclosureTabController.prototype.onStart.call(this);

      this.listenTo(this.getResource('workflowTaskModel'), 'sync', function(workflowTaskModel, resp, options) {
        if (options.syncMethod === 'create' || options.syncMethod === 'update') {
          this.fetchResource('routingHistoryCollection');
        }
      });
    },
  });

  module.exports = DisclosureHistoryTabController;
});

